import { render, staticRenderFns } from "./ProfitNotification.vue?vue&type=template&id=003a8e68&"
import script from "./ProfitNotification.vue?vue&type=script&lang=js&"
export * from "./ProfitNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports